import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { DatePicker } from "antd";
import { useQuery } from "react-query";
import TurnOver from "../component/turnover";
import TransfertOperator from "../component/transfertOperator";
import NewMerchant from "../../merchand/pages/newMerchant";
import "../utils/style.css";
import {
  getMetricsByMerchandId,
  getMetricsTransByMerchandId,
} from "../../developer/services/developerApi";
import TransferByCountry from "../component/transfertByCountry";
import CardMetrics from "../../../common/card/cardMetric";

const Home = () => {
  
  const [amount, setAmount] = useState(0);

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

  const merchandId = currentUser?.user?.id || currentUser?.user?.merchantId;

  const [kycVerified, setkycVerified] = useState(null);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("authUser"));
    setkycVerified(user?.kycVerified);
  }, []);

  const {
    data: metrics,
    isLoading: isLoadingMetric,
    isError: isErrorMetric,
    error: errorMetric,
  } = useQuery(
    ["metrics", merchandId],
    () => getMetricsByMerchandId(merchandId),
    { enabled: !!merchandId },
  );

  const {
    data: transfert,
    isLoading: isLoadingTrans,
    isError: isErrorTrans,
    error: errorTrans,
  } = useQuery(
    ["transfert", merchandId],
    () => getMetricsTransByMerchandId(merchandId),
    { enabled: !!merchandId },
  );

  return (
    <div>
      {kycVerified === false ? (
        <NewMerchant />
      ) : kycVerified === true ? (
        <>
          <div className="title-page-country mb-4">
            Tableau de bord{" "}
            <DatePicker placeholder="2025" picker="year" className="dashboardDate"/>
          </div>

          <CardMetrics
            data={metrics}
            isLoading={isLoadingMetric}
            isError={isErrorMetric}
            error={errorMetric}
            turnOver={amount}
          />

          <TransferByCountry
            data={transfert}
            isLoading={isLoadingTrans}
            isError={isErrorTrans}
            error={errorTrans}
          />

          <Row className="mb-2">
            <Col lg={8} className="mb-2">
              <TurnOver title="Chiffre d'affaires" setAmountForHome={setAmount} />
            </Col>
            <Col lg={4} className="mb-2">
              <TransfertOperator />
            </Col>
          </Row>
        </>
      ) : (
        <div className="dashb-skeleton-container">
          <div className="dashb-skeleton dashb-title"></div>

          <div className="dashb-cards">
            <div className="dashb-skeleton dashb-card"></div>
            <div className="dashb-skeleton dashb-card"></div>
            <div className="dashb-skeleton dashb-card"></div>
          </div>

          <div className="dashb-skeleton dashb-chart"></div>

          <div className="dashb-row">
            <div className="dashb-skeleton dashb-chart-small"></div>
            <div className="dashb-skeleton dashb-chart-small"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
